import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    Signal
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingSpinnerBorderComponent } from '../loading-spinner-border/loading-spinner-border.component';

@Component({
    selector: 'overlay-loading-spinner-border',
    imports: [CommonModule, LoadingSpinnerBorderComponent],
    template: `
        @if (show()) {
            <div class="overlay-spinner">
                <loading-spinner-border />
            </div>
        }
    `
})
export class OverlayLoadingSpinnerBorderComponent implements OnInit, OnDestroy {
    @Input() show!: Signal<boolean>;

    element!: HTMLElement;

    ngOnInit(): void {
        if (this.show && this.show()) {
            this.element = document.createElement("div");
            this.element.className = "overlay";
            document.body.appendChild(this.element);
        }
    }
    
    ngOnDestroy(): void {
        if (this.element && document.body.contains(this.element)) {
            document.body.removeChild(this.element);
        }
    }
}